import { Container, Row } from "react-bootstrap";

import headerImage from "../../assets/header.jpg";

import "./layoutStyles.css";

const Layout = ({ children }) => {
  return (
    <Container fluid className="geo-container">
      <Row>
        <img className="w-100" src={headerImage} alt="cloud" />
      </Row>
      <Row>{children}</Row>
    </Container>
  );
};

export default Layout;
